import React from "react";
import { ContextMenuContext } from "./ContextMenuContext";
import ContextMenuItemElement from "./ContextMenuItem";
import Logger from "../../foundation/Logger";

type MenuItems =
    | React.ReactElement<ContextMenuItemElement>[]
    | React.ReactElement<ContextMenuItemElement>;

interface ContextFragmentProps {
    name: string;
    children?: MenuItems;
}

class ContextFragment extends React.Component<ContextFragmentProps> {
    static contextType = ContextMenuContext;
    context!: React.ContextType<typeof ContextMenuContext>;

    static getChildren(props: ContextFragmentProps) {
        return (
            (props.children instanceof Array
                ? props.children
                : [
                      props.children,
                  ]) as React.ReactElement<ContextMenuItemElement>[]
        ).map(item => item.props);
    }

    previousSnapshot: string;

    componentDidMount() {
        Logger.info(`ContextFragment "${this.props.name}" mounted`);
        const children = ContextFragment.getChildren(this.props);
        this.previousSnapshot = JSON.stringify(children);
        this.context.addMenuItems(children);
    }

    componentDidUpdate() {
        Logger.info(`ContextFragment "${this.props.name}" updated`);
        const children = ContextFragment.getChildren(this.props);
        const snapshot = JSON.stringify(children);
        if (this.previousSnapshot !== snapshot) {
            this.previousSnapshot = snapshot;
            this.context.addMenuItems(children);
        }
    }

    render() {
        return null;
    }
}

export default ContextFragment;
